const styles = theme => ({ button: { marginRight: theme.spacing(1) } })

export default styles
